import { render, staticRenderFns } from "./Customerstatement.vue?vue&type=template&id=44f57f0f&scoped=true&"
import script from "./Customerstatement.vue?vue&type=script&lang=js&"
export * from "./Customerstatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f57f0f",
  null
  
)

export default component.exports